import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import TranslationDialog from "./TranslationDialog";
import { connect } from "react-redux";
import { useDialog } from "../../licensing/utils/DialogProvider";
import { locale, translationMode } from "../../store/reducers/translations";
import { getText } from "../../translations/utils";
import { store } from "../../store";

export type Translation = {
  tKey: string;
  tDefault: string | undefined;
};

export const exceptionsToTranslate: Translation[] = [];

export const allRenderedTranslations: Translation[] = [];

export const getTranslation = (tKey: string, tDefault: string | null = null) => {
  if (tDefault == null) {
    tDefault = tKey;
  }
  const translations = store.getState().translations.translations;

  if (translationMode && !exceptionsToTranslate.some((translation) => translation.tKey === tKey)) {
    exceptionsToTranslate.push({ tDefault, tKey });
  }
  if (translationMode && !allRenderedTranslations.some((translation) => translation.tKey === tKey)) {
    allRenderedTranslations.push({ tDefault, tKey });
  }

  let langCode = locale;
  if (store.getState().user !== undefined && store.getState().user.lang !== undefined) {
    langCode = store.getState().user.lang;
  }

  let translationValue = translations[langCode.toLowerCase()]?.[tKey]; // ?? translations["en"][tKey];

  if (!translationValue) {
    const explodedKey = tKey.split(".");
    if (explodedKey.length > 1) {
      const type = explodedKey[0];
      explodedKey.splice(0, 1);
      translationValue = getText(type, explodedKey.join("."), tDefault);
    }
  }

  if (!translationValue) {
    translationValue = translations["en"] ? (translations["en"][tKey] ?? tDefault) : tDefault;
  }

  return translationValue;
};

const TranslationWrapper = (props: {
  tDefault?: string;
  tStyle?: object;
  translations?: any;
  tKey: string;
  languagesToTranslate?: any;
  translationMode?: boolean;
  displayedLanguage?: any;
}) => {
  const [openDialog] = useDialog();
  const { translations, tKey, languagesToTranslate, translationMode, displayedLanguage } = props;
  const element = useRef<HTMLElement | null>(null);
  let tDefault = props.tDefault;
  const tStyle = props.tStyle;
  if (tDefault == null) {
    tDefault = tKey;
  }

  useEffect(() => {
    if (element.current?.parentElement) {
      element.current.parentElement.style.outline = "1px dashed"; //!newTranslationValue ? "1px dashed" : "1px double";
      element.current.parentElement.style.outlineColor = translationsComplete ? "gray" : "red";
      element.current.parentElement.onclick = (e) => {
        if (e.altKey) {
          e.preventDefault();
          e.stopPropagation();
          openDialog({
            children: <TranslationDialog tDefault={tDefault} tKey={tKey} />,
            fullWidth: true,
            maxWidth: "lg",
            disableBackdropClick: true,
          });
        }
      };
    }
  }, [element]);

  let translationValue;
  if (!translationMode) {
    let langCode = locale;
    if (store.getState().user !== undefined && store.getState().user.lang !== undefined) {
      langCode = store.getState().user.lang;
    }

    translationValue = translations[langCode.toLowerCase()]?.[tKey];
    if (!translationValue) {
      const explodedKey = tKey.split(".");
      if (explodedKey.length > 1) {
        const type = explodedKey[0];
        explodedKey.splice(0, 1);
        translationValue = getText(type, explodedKey.join("."), tDefault);
      }
    }
    if (!translationValue) {
      translationValue = translations["en"] ? (translations["en"][tKey] ?? tDefault) : tDefault;
    }
    if (!tStyle) {
      return translationValue;
    } else {
      return <span style={tStyle}>{translationValue}</span>;
    }
  }

  const translationsComplete = languagesToTranslate.every((language) => translations[language]?.[tKey]?.length > 0);

  if (!allRenderedTranslations.some((translation) => translation.tKey === tKey)) {
    allRenderedTranslations.push({ tDefault, tKey });
  }

  translationValue =
    translations[displayedLanguage]?.[tKey] != null && translations[displayedLanguage][tKey] !== ""
      ? translations[displayedLanguage][tKey]
      : null;
  if (!translationValue) {
    const explodedKey = tKey.split(".");
    if (explodedKey.length > 1) {
      const type = explodedKey[0];
      explodedKey.splice(0, 1);
      translationValue = getText(type, explodedKey.join("."), tDefault);
    }
    if (!translationValue) {
      translationValue = translations["en"][tKey] ?? tDefault;
    }
  }

  return [translationValue, <div key={tDefault} ref={element} style={{ ...tStyle, visibility: "hidden" }} />];
};

TranslationWrapper.propTypes = {
  tKey: PropTypes.string.isRequired,
  tDefault: PropTypes.string,
  tStyle: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    translations: state.translations.translations,
    languagesToTranslate: state.translations.languagesToTranslate,
    translationMode: state.translations.translationMode,
    displayedLanguage: state.translations.displayedLanguage,
  };
};

export default connect(mapStateToProps)(TranslationWrapper);
